import login from './login';
import resetPassword from './resetPassword';
import footer from './footer';

export default {
  login,
  resetPassword,
  footer,
};
